import React, { Component } from 'react';
import debounce from 'lodash.debounce';
import PropTypes from 'prop-types';
import { triggerEdapEvent } from '../../utils/edap';
import { MODULE_VIEW_EVENT } from './events';

class EdapModuleView extends Component {
  constructor(props) {
    super(props);
    this.onWindowScroll = debounce(this.onWindowScroll, 300);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onWindowScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onWindowScroll);
  }

  onWindowScroll = () => {
    const { offsetHeight, offsetTop } = this.el;
    const { scrollY, innerHeight } = window;

    // We consider that the user has seen the component when it's fully visible
    const componentIsVisible = (scrollY + innerHeight) >= (offsetTop + offsetHeight);

    if (componentIsVisible) {
      const { eventOptions, onModuleViewed } = this.props;

      triggerEdapEvent(MODULE_VIEW_EVENT, eventOptions);

      onModuleViewed();

      window.removeEventListener('scroll', this.onWindowScroll);
    }
  }

  setEl = (node) => {
    this.el = node;
  }

  render() {
    return (
      <div ref={this.setEl}>
        {this.props.children}
      </div>
    );
  }
}

EdapModuleView.defaultProps = {
  onModuleViewed: () => {}
};

EdapModuleView.propTypes = {
  eventOptions: PropTypes.shape({
    actionlocation: PropTypes.string
  }).isRequired,
  onModuleViewed: PropTypes.func
};

export default EdapModuleView;



// WEBPACK FOOTER //
// ./src/universal/components/EdapModuleView/EdapModuleView.js